import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import { ActivityComponent } from './activity.component';
import { ActivityListComponent } from './activity-list/activity-list.component';
import { ActivityAddComponent } from './activity-add/activity-add.component';
import { ActivityEditComponent } from './activity-edit/activity-edit.component';

const routes: Routes = [
  {
    path: '',
    component: ActivityComponent,
    children: [
      {
        path: '',
        component: ActivityListComponent
      },
      {
        path: 'add',
        component: ActivityAddComponent
      },
      {
        path: 'edit/:id',
        component: ActivityEditComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ActivityRoutingModule {
}
